export const Div1 = () => (
  <div className="flex flex-col text-center items-center text-white gap-8 max-w-2xl">
    <span className="text-xl md:text-2xl italic">
      L’Atelier vous adresse ses&nbsp;meilleurs vœux pour cette&nbsp;nouvelle année, qu’elle soit synonyme de réussite et de succès durables.
    </span>

    <a href="/wallpaper.png" download className="button mt-8">
      Télécharger le fond d’écran
    </a>

    <button
      onClick={() => window.location.reload()}
      className="absolute -bottom-7 md:-bottom-9 text-white/70 hover:text-white underline text-sm cursor-pointer bg-transparent border-none"
    >
      Recommencer l’expérience
    </button>
  </div>
);
